<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-file-text-o mr-2" />List Request Invoice
                Void
            </h5>
            <hr />
            <b-row class="align-items-end">
                <b-col md="3">
                    <b-form-group label="Status">
                        <multiselect
                            v-model="filter.status"
                            :options="statusOptions"
                            label="label"
                            track-by="value"
                            placeholder="Filter Status..."
                            :allow-empty="true"
                            deselect-label=""
                            select-label=""
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-button class="mb-3" variant="primary" @click="getItems()">
                        <i class="fa fa-search mr-2" />Cari
                    </b-button>
                </b-col>
            </b-row>
            <b-table
                bordered
                hover
                show-empty
                :items="items"
                :fields="fields"
                responsive
                class="my-3"
            >
                <template v-slot:empty>
                    Tidak ada data request invoice void.
                </template>
                <template v-slot:cell(invoice_id)="row">
                    <strong>{{ row.item.invoice_id }}</strong>
                </template>
                <template v-slot:cell(billing)="row">
                    <div>Rp. {{ $helper.formatThousand(row.item.total) }}</div>
                    <div class="small">
                        Diskon: <strong>{{ row.item.discount }}%</strong>
                        <strong v-if="row.item.discount_value">
                            (Rp. {{ $helper.formatThousand(row.item.discount_value) }})
                        </strong>
                    </div>
                    <div class="small">
                        Sisa: <strong>Rp. {{ $helper.formatThousand(row.item.outstanding_payment) }}</strong>
                    </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="getStatusBadge(row.item.status)">
                        {{ getStatusLabel(row.item.status) }}
                    </b-badge>
                </template>
                <template v-slot:cell(approval)="row">
                    <div class="small mt-1">
                        Dibuat: {{ $helper.parseDate(row.item.requested_at) }},
                        {{ $helper.parseHourMinute(row.item.requested_at) }} oleh {{ row.item.requested_by }}
                        <br />
                        <template v-if="row.item.approved_at">
                            <template v-if="row.item.status == 2">
                                Ditolak:
                            </template> <template v-else>
                                Disetujui:
                            </template> 
                            {{ $helper.parseDate(row.item.approved_at) }},
                            {{ $helper.parseHourMinute(row.item.approved_at) }} oleh {{ row.item.approved_by }}
                        </template>
                    </div>
                </template>
                <template v-slot:cell(reason)="row">
                    <span :title="row.item.reason">
                        {{ truncateText(row.item.reason, 50) }}
                    </span>
                </template>
                <template v-slot:cell(action)="row">
                    <template v-if="row.item.status === 0">
                        <b-button
                            size="sm"
                            variant="success"
                            class="mr-2"
                            v-b-tooltip.hover.top
                            title="Approve"
                            @click="promptApprove(row.item)"
                        >
                            <i class="fa fa-fw fa-check" />
                        </b-button>
                        <b-button
                            size="sm"
                            variant="danger"
                            v-b-tooltip.hover.top
                            title="Reject"
                            @click="promptReject(row.item)"
                        >
                            <i class="fa fa-fw fa-times" />
                        </b-button>
                    </template>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>

        <b-modal
            id="m-approve"
            title="Approve Request Void"
            centered
            hide-footer
            no-close-on-backdrop
        >
            <p>
                Apakah anda yakin ingin <strong>menyetujui</strong> request void
                untuk No. Faktur <strong>{{ activeItem.no_faktur }}</strong
                >?
            </p>
            <div class="mt-4 text-right">
                <b-button
                    variant="success"
                    :disabled="isSubmitting"
                    @click="execApprove"
                >
                    <span v-if="isSubmitting">
                        <i class="fa fa-spinner fa-spin mr-1" />
                        Memproses...
                    </span>
                    <span v-else>Approve</span>
                </b-button>
            </div>
        </b-modal>

        <b-modal
            id="m-reject"
            title="Reject Request Void"
            centered
            hide-footer
            no-close-on-backdrop
        >
            <p>
                Apakah anda yakin ingin <strong>menolak</strong> request void
                untuk No. Faktur <strong>{{ activeItem.no_faktur }}</strong
                >?
            </p>
            <b-form-group label="Alasan Penolakan">
                <b-textarea
                    v-model="inputNotes"
                    rows="3"
                    placeholder="Masukkan alasan penolakan..."
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    variant="danger"
                    :disabled="isSubmitting"
                    @click="execReject"
                >
                    <span v-if="isSubmitting">
                        <i class="fa fa-spinner fa-spin mr-1" />
                        Memproses...
                    </span>
                    <span v-else>Reject</span>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import EnumPermissions from "@/shared/enum-permissions";

export default {
    name: "ListRequestInvoice",
    data() {
        return {
            initStatus: 0,
            isSubmitting: false,
            items: [],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],
            filter: {
                search: "",
                status: null
            },
            statusOptions: [
                { value: null, label: "SEMUA" },
                { value: 0, label: "PENDING" },
                { value: 1, label: "APPROVED" },
                { value: 2, label: "REJECTED" }
            ],
            fields: [
                { key: "no_faktur", label: "No. Faktur" },
                { key: "billing", label: "Total / Diskon / Sisa" },
                { key: "reason", label: "Alasan" },
                { key: "notes", label: "Catatan", sortable: false },
                { key: "approval", label: "Approval & Waktu", sortable: false },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" }
            ],
            activeItem: {
                id: null,
                invoice_id: null
            },
            inputNotes: ""
        };
    },
    methods: {
        init() {
            this.initStatus = 0;
            this.getItems()
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(() => {
                    this.initStatus = -1;
                });
        },
        getItems(page = 1) {
            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );

            if (!this.$helper.isBlank(this.filter.search)) {
                param += "&search=" + this.filter.search;
            }

            if (this.filter.status !== null) {
                param += "&status=" + this.filter.status.value;
            }

            return this.$axios
                .get("invoice-void" + param)
                .then(res => {
                    this.items = res.data.data.items || [];
                    this.totalRows = res.data.data.total || 0;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    throw error;
                });
        },
        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },
        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },
        getStatusLabel(status) {
            switch (status) {
                case 0:
                    return "PENDING";
                case 1:
                    return "APPROVED";
                case 2:
                    return "REJECTED";
                default:
                    return "-";
            }
        },
        getStatusBadge(status) {
            switch (status) {
                case 0:
                    return "warning";
                case 1:
                    return "success";
                case 2:
                    return "danger";
                default:
                    return "secondary";
            }
        },
        truncateText(text, maxLength) {
            if (!text) return "-";
            if (text.length <= maxLength) return text;
            return text.substring(0, maxLength) + "...";
        },
        promptApprove(item) {
            this.activeItem = item;
            this.inputNotes = "";
            this.$bvModal.show("m-approve");
        },
        promptReject(item) {
            this.activeItem = item;
            this.inputNotes = "";
            this.$bvModal.show("m-reject");
        },
        execApprove() {
            this.isSubmitting = true;
            this.$axios
                .post(`invoice-void/approve/${this.activeItem.id}`)
                .then(() => {
                    this.$helper.toastSuccess(
                        this,
                        "Request void berhasil disetujui!"
                    );
                    this.$bvModal.hide("m-approve");
                    this.getItems();
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isSubmitting = false;
                });
        },
        execReject() {
            if (!this.inputNotes.trim()) {
                return this.$helper.toastError(
                    this,
                    "Mohon masukkan alasan penolakan!"
                );
            }

            this.isSubmitting = true;
            this.$axios
                .post(`invoice-void/reject/${this.activeItem.id}`, {
                    notes: this.inputNotes
                })
                .then(() => {
                    this.$helper.toastSuccess(
                        this,
                        "Request void berhasil ditolak!"
                    );
                    this.$bvModal.hide("m-reject");
                    this.getItems();
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isSubmitting = false;
                });
        }
    },
    created() {
        this.init();
    }
};
</script>
